import getUrlVars from "./getUrlVars";

const getUrlVar = function(name){
  return getUrlVars()[name];
}

export default getUrlVar;
